import { LottiePlayer } from '@repo/ui';
import { AuthGuard } from '@repo/user-session';

import Layout from '@/components/layout/Layout';
import { DecisionRefundContent } from '@/components/tax-refund/individual/DecisionRefund/Result/DecisionRefundContent';

const DecisionRefundDecisionAcceptPage = () => {
  return (
    <AuthGuard>
      <Layout>
        <DecisionRefundContent
          graphic={<LottiePlayer src={`${process.env.NEXT_PUBLIC_RESOURCE_CENTER_URL}/refund/lotties/ani_check.json`} loop className={'w-20 h-20'} />}
          title={`국세청에서\n환급이 결정되었어요!`}
          description={`자세한 내용은 영업일 기준 2일 내에\n카카오톡 알림톡으로 안내해드릴게요.`}
        />
      </Layout>
    </AuthGuard>
  );
};

export default DecisionRefundDecisionAcceptPage;
